import {
  STATUS_ORDER_ALL,
  STATUS_ORDER_WILL_PAY,
  STATUS_ORDER_WILL_TRANSPORT,
  STATUS_ORDER_WILL_RECEIVE,
  STATUS_ORDER_RECEIVED,
  STATUS_ORDER_CANCELED,
  STATUS_ORDER_WILL_AUDIT,
  STATUS_ORDER_RECEIVED_UNPAY,
  STATUS_ORDER_RECEIVED_PAYED,
  STATUS_ORDER_AUDITED,

  PAY_METHOD_ALIPAY,
  PAY_METHOD_WEIXINPAY,
  PAY_METHOD_ACCOUNTCREDIT,
  PAY_METHOD_FACECASH,
  PAY_METHOD_TRANSFER,

  STATUS_PAY_IDLE,
  STATUS_PAY_SUCCESS,
  STATUS_PAY_FAILED,

  SIGNIN_METHOD_WEIXIN_QRCODE,
  SIGNIN_METHOD_ALIPAY_QRCODE,
  SIGNIN_METHOD_CASH,
  SIGNIN_METHOD_SIGNIN,

  STAT_PERIOD_DAY,
  STAT_PERIOD_WEEK,
  STAT_PERIOD_MONTH
} from 'rpc/MisComm/MisComm'

const OrderStatusMap = {
  [STATUS_ORDER_ALL]: '全部',
  [STATUS_ORDER_WILL_PAY]: '待付款',
  [STATUS_ORDER_WILL_TRANSPORT]: '待发货',
  [STATUS_ORDER_WILL_RECEIVE]: '待收货',
  [STATUS_ORDER_RECEIVED]: '已收货',
  [STATUS_ORDER_CANCELED]: '已取消'
}

const BuyOrderStatusMap = {
  [STATUS_ORDER_ALL]: '全部',
  [STATUS_ORDER_WILL_AUDIT]: '待审核',
  [STATUS_ORDER_AUDITED]: '已审核',
  [STATUS_ORDER_RECEIVED]: '已收货',
  [STATUS_ORDER_CANCELED]: '已取消'
}

const PointOrderStatusMap = {
  [STATUS_ORDER_ALL]: '全部',
  [STATUS_ORDER_WILL_TRANSPORT]: '待发货',
  [STATUS_ORDER_WILL_RECEIVE]: '待收货',
  [STATUS_ORDER_RECEIVED]: '已收货'
}

const OrderPayMethodMap = {
  [PAY_METHOD_ALIPAY]: '支付宝',
  [PAY_METHOD_WEIXINPAY]: '微信支付',
  [PAY_METHOD_ACCOUNTCREDIT]: '账期支付',
  [PAY_METHOD_FACECASH]: '货到付款',
  [PAY_METHOD_TRANSFER]: '银行转账'
}

const OrderPayStatusMap = {
  [STATUS_PAY_IDLE]: '等待付款',
  [STATUS_PAY_SUCCESS]: '付款成功',
  [STATUS_PAY_FAILED]: '付款失败'
}

const districtList = {
  province_list: {
    110000: '上海'
  },
  city_list: {
    110100: '上海市'
  },
  county_list: {
    110101: '黄浦区',
    110102: '徐汇区',
    110103: '长宁区',
    110104: '静安区',
    110105: '普陀区',
    110106: '虹口区',
    110107: '杨浦区',
    110108: '闵行区',
    110109: '宝山区',
    110110: '嘉定区',
    110111: '浦东新区',
    110112: '金山区',
    110113: '松江区',
    110114: '青浦区',
    110115: '奉贤区',
    110116: '崇明区',
    110117: '其它区'
  }
}

const monthNames = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月'
]

const normalTimeout = 10000
const orderPayTime = 3600 // unit second

const spuTypeMap = {
  normal: 'NORMAL',
  point: 'POINT'
}
const TYPE_ORDER_BATCH = 'batch'
const orderTypeList = [{type: STATUS_ORDER_ALL, iconName: 'file-text-o', title: '我的订单'},
  {type: STATUS_ORDER_WILL_PAY, iconName: 'credit-card-alt', title: '待付款'},
  {type: STATUS_ORDER_WILL_TRANSPORT, iconName: 'archive', title: '待发货'},
  {type: STATUS_ORDER_WILL_RECEIVE, iconName: 'truck', title: '待收货'},
  {type: STATUS_ORDER_CANCELED, iconName: 'times-circle', title: '已取消'}]
//  {type: TYPE_ORDER_BATCH, iconName: 'tasks', title: '批量订单'}]
const sellerOrderTypeList = [{type: STATUS_ORDER_ALL, iconName: 'file-text-o', title: '我的订单'},
  {type: STATUS_ORDER_WILL_PAY, iconName: 'credit-card-alt', title: '待支付'},
  {type: STATUS_ORDER_WILL_AUDIT, iconName: 'tasks', title: '待审核'},
  {type: STATUS_ORDER_WILL_TRANSPORT, iconName: 'archive', title: '待发货'},
  {type: STATUS_ORDER_WILL_RECEIVE, iconName: 'truck', title: '待收货'}]

const batchTypeItem = {type: TYPE_ORDER_BATCH, title: '批量订单', desc: ''}
const willAuditItem = {type: STATUS_ORDER_WILL_AUDIT, title: '待审核', desc: ''}
const orderTypes = [{type: STATUS_ORDER_ALL, title: '全部', desc: ''},
  {type: STATUS_ORDER_WILL_PAY, title: '待付款', desc: '等待付款'},
  {type: STATUS_ORDER_WILL_TRANSPORT, title: '待发货', desc: '等待发货'},
  {type: STATUS_ORDER_WILL_RECEIVE, title: '待收货', desc: '等待收货'},
  {type: STATUS_ORDER_RECEIVED, title: '已收货', desc: '交易完成'},
  {type: STATUS_ORDER_CANCELED, title: '已取消', desc: '交易关闭'}]

const sellerOrderTypes = [{type: STATUS_ORDER_ALL, title: '全部', desc: ''},
  {type: STATUS_ORDER_WILL_PAY, title: '待支付', desc: '等待支付'},
  {type: STATUS_ORDER_WILL_AUDIT, title: '待审核', desc: '等待审核'},
  {type: STATUS_ORDER_WILL_TRANSPORT, title: '待发货', desc: '等待发货'},
  {type: STATUS_ORDER_WILL_RECEIVE, title: '待收货', desc: '等待收货'},
  {type: STATUS_ORDER_RECEIVED_UNPAY, title: '未付款', desc: '已收货未付款'},
  {type: STATUS_ORDER_RECEIVED_PAYED, title: '已完成', desc: '已完成'},
  {type: STATUS_ORDER_CANCELED, title: '已取消', desc: '交易关闭'}]

const buyerOrderTypes = [{type: STATUS_ORDER_ALL, title: '全部', desc: ''},
  {type: STATUS_ORDER_WILL_AUDIT, title: '待审核', desc: '等待审核'},
  {type: STATUS_ORDER_AUDITED, title: '已审核', desc: '已审核等待收货'},
  {type: STATUS_ORDER_RECEIVED, title: '已收货', desc: '已收货'},
  {type: STATUS_ORDER_CANCELED, title: '已取消', desc: '交易关闭'}]

const pointOrderTypes = [{type: STATUS_ORDER_ALL, title: '全部', desc: ''},
  {type: STATUS_ORDER_WILL_TRANSPORT, title: '待发货', desc: '等待发货'},
  {type: STATUS_ORDER_WILL_RECEIVE, title: '待收货', desc: '等待收货'},
  {type: STATUS_ORDER_RECEIVED, title: '已收货', desc: '交易完成'}]

const SigninMethodMap = {
  [SIGNIN_METHOD_WEIXIN_QRCODE]: '微信二维码付款',
  [SIGNIN_METHOD_ALIPAY_QRCODE]: '支付宝二维码付款',
  [SIGNIN_METHOD_CASH]: '现金付款',
  [SIGNIN_METHOD_SIGNIN]: '立即签收'
}

const deliveryItem = [{type: 'delay', title: '已延迟', desc: '延迟订单'},
  {type: 'tomorrow', title: '明日订单', desc: '明日订单'},
  {type: 'planned', title: '已规划', desc: '已规划订单'},
  {type: 'unplanned', title: '未规划', desc: '未规划订单'}]

const StatPeriodMap = {
  [STAT_PERIOD_DAY]: '天',
  [STAT_PERIOD_WEEK]: '周',
  [STAT_PERIOD_MONTH]: '月'
}

const roleNameMap = {
  'unkown': '未知',
  'buyManager': '采购管理',
  'buyOperator': '采购员',
  'sellManager': '销售管理',
  'sellOperator': '销售员',
  'platformManager': '平台管理员',
  'platformOperator': '平台操作员',
  'deliveryOperator': '配送员',
  'financialOperator': '财务操作员',
  'storeOperator': '仓库管理员'
}

const companyTypes = {
  'all': '全部',
  'company': '企业',
  'privately': '个体工商户',
  'user': '个人零售'
}

const customerTypeList = {
  'company': '企业',
  'privately': '个体工商户',
  'user': '个人零售'
}

const starClass = {
  '1': '1星极差',
  '2': '2星整改',
  '3': '3星正常',
  '4': '4星良好',
  '5': '5星最优'
}

const chargeTypeMap = {
  'TYPE_BUYER': 'buyer',
  'TYPE_SELLER': 'seller'
}

export default {
  OrderStatusMap,
  OrderPayMethodMap,
  OrderPayStatusMap,
  districtList,
  monthNames,
  normalTimeout,
  orderPayTime,
  spuTypeMap,
  orderTypes,
  sellerOrderTypes,
  SigninMethodMap,
  StatPeriodMap,
  PointOrderStatusMap,
  pointOrderTypes,
  batchTypeItem,
  willAuditItem,
  TYPE_ORDER_BATCH,
  orderTypeList,
  sellerOrderTypeList,
  roleNameMap,
  customerTypeList,
  companyTypes,
  starClass,
  chargeTypeMap,
  deliveryItem,
  buyerOrderTypes
}



// WEBPACK FOOTER //
// ./src/common/const.js